export default {
  name: "BigRadialBackground"
};